import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { isSingleEmbeddedDatasource } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';

import { Messages } from '../../codegen/Localize';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { FeatureFlags } from '../../ts/FeatureFlags';
import { IPredictiveModelAction } from '../../ts/ServerApi/types/actionNames';
import { newPredictiveModelForDatasource } from './NewPredictiveModelForDatasourceAction';
export const NewPredictiveModelEntityAction: IEntityAction<IContentInfo<'datasource'>, IPredictiveModelAction> = {
  name: EntityActionNames.NewPredictiveModel,
  translateName: Messages.newPredictiveModel,
  isVisible: (targetItems: IContentInfo[]) => {
    return FeatureFlags.prometheusPredictiveModelEnabled && !isSingleEmbeddedDatasource(targetItems);
  },
  isClickable: (availableActions: IPredictiveModelAction, targetItems: IContentInfo[]) =>
      targetItems.length === 1 &&availableActions && availableActions.createPredictiveModel ,
  createReduxAction: (targetItems: IContentInfo[]) => {
    if (targetItems.length !== 1) {
      return;
    }

    const item = targetItems[0];
    if (item.contentType === 'datasource') {
      return newPredictiveModelForDatasource(item);
    }
  }
};
